/** @jsx jsx */
import React, { useEffect } from "react"
import { jsx } from "@emotion/core"
import { Button, TextTag as Text } from "../../atoms"
import PropTypes from "prop-types"
import { primaryheaderStyle, primaryButtonStyle } from "./styles"

/**
- Standard Page Header component for displaying textual user information/messages.
- Based on top of Ant [typography][Button], This component accepts all of antd typography/ button props and more.
**/
export const PageHeader = props => {
  const {
    btnText,
    headerText,
    onClick,
    btnSize,
    icon,
    disabled,
    showButton,
    ...rest
  } = props

  useEffect(() => {
    // Setting page screen status and title to null to add state to browser's session history stack
    window.history.pushState(null, null, window.location.href)
    window.onpopstate = e => {
      // Handle Browser Back button click
      if (disabled) {
        // If disabled redirect back to same page
        window.history.go(1)
      } else {
        if (onClick) {
          onClick()
        }
      }
    }
  }, [disabled])
  return (
    <div className="pageHeader" css={primaryheaderStyle}>
      {showButton ? (
        <Button
          onClick={onClick}
          btnSize={btnSize}
          icon={icon}
          disabled={disabled}
          css={primaryButtonStyle}
        >
          {btnText}
        </Button>
      ) : (
        ""
      )}
      <Text textType="pageHeading">{headerText}</Text>
    </div>
  )
}

PageHeader.propTypes = {
  /** The type of the button */
  btnType: PropTypes.oneOf(["default", "primary", "secondary", "bordered"]),
  /** The size of the button */
  btnSize: PropTypes.oneOf(["large", "small"]),
  /** Disable button */
  disabled: PropTypes.bool,
  /** Gets called when the user clicks on the button */
  onClick: PropTypes.func,
  /** header content */
  children: PropTypes.node,
  /** button text */
  btnText: PropTypes.string,
  /** show or hide button */
  showButton: PropTypes.bool,
  /** header message */
  headerText: PropTypes.string,
}

PageHeader.defaultProps = {
  btnType: "default",
  btnSize: "small",
  showButton: true,
}
